var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#2173FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16667C8 8.85725 8.12292 8.5605 8.34171 8.34171C8.5605 8.12292 8.85725 8 9.16667 8H20.8333C21.1428 8 21.4395 8.12292 21.6583 8.34171C21.8771 8.5605 22 8.85725 22 9.16667V20.8333C22 21.1428 21.8771 21.4395 21.6583 21.6583C21.4395 21.8771 21.1428 22 20.8333 22H9.16667C8.85725 22 8.5605 21.8771 8.34171 21.6583C8.12292 21.4395 8 21.1428 8 20.8333V9.16667Z",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1109 8V22M11.8887 13.4444L13.4442 15L11.8887 16.5556M15.7776 8H20.4442M15.7776 22H20.4442",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseV2);
export default __webpack_public_path__ + "static/media/collapse_v2.b133e130df17142deba8dc8fad4b5afe.svg";
export { ForwardRef as ReactComponent };